/**
 * Canonical Jinja `{{ ... }}` names used in tutor prompt templates (see ai-tutor prompt_seed / tutor_main).
 * These are **not** the same as Mongo `prompt_blocks.key` (e.g. BASE_TEACHER_RULES).
 */
export const TUTOR_TEMPLATE_SLOT_KEYS: readonly { key: string; description: string }[] = [
  { key: 'grade', description: 'Runtime: learner grade' },
  { key: 'lesson_no', description: 'Runtime: lesson number' },
  { key: 'lesson_style', description: 'Runtime: lesson style' },
  { key: 'lesson_type', description: 'Runtime: lesson type (story, vocab, …)' },
  { key: 'lesson_ctx', description: 'Runtime: lesson / RAG context body' },
  { key: 'topic_ctx', description: 'Runtime: topic context (communication tutor)' },
  { key: 'dialect', description: 'Runtime: dialect label' },
  { key: 'base_rules', description: 'Injected block: base teacher rules' },
  { key: 'dialect_instruction_block', description: 'Injected: dialect instruction text' },
  { key: 'lesson_type_rules', description: 'Injected: rules for current lesson type' },
  { key: 'mode_rules', description: 'Injected: mode rules (FREE / TOPIC / LESSON)' },
  { key: 'source_rules', description: 'Injected: source / citation rules' },
  { key: 'final_output_check', description: 'Injected: Tamil-only output check' },
  { key: 'communication_rules', description: 'Injected: communication tutor rules (if used)' },
] as const;

export function slotKeysSet(): Set<string> {
  return new Set(TUTOR_TEMPLATE_SLOT_KEYS.map((s) => s.key));
}
